import PageContainer from '../../../../components/common/PageContainer';
import OperatorLicenseTypeTable from './HEOperatorCertificateTypeTable';

function HEOperatorCertificateTypePage() {
  return (
    <>
      <PageContainer
        title='Personnel Databases'
        subTitle='HE Operator Certificate Type Master'
        showDate
      >
        <OperatorLicenseTypeTable />
      </PageContainer>
    </>
  );
}

export default HEOperatorCertificateTypePage;
